// Duration options
export const DURATIONS = [4, 7, 10, 14];

// Results per page options
export const RESULTS_PER_PAGE_OPTIONS = [2, 5, 10];

// Sort options
export const SORT_OPTIONS = [
  { value: 'default', label: 'Recommended' },
  { value: 'price-asc', label: 'Price (Low to High)' },
  { value: 'price-desc', label: 'Price (High to Low)' },
  { value: 'date-asc', label: 'Departure (Earliest First)' },
  { value: 'date-desc', label: 'Departure (Latest First)' },
  { value: 'stars-desc', label: 'Star Rating (Highest First)' },
  { value: 'stars-asc', label: 'Star Rating (Lowest First)' }
];

// Date constraints
export const MAX_FUTURE_MONTHS = 18;

// Price history settings
export const PRICE_HISTORY_MAX_DAYS = 90;

// Default values
export const DEFAULT_RESULTS_PER_PAGE = 10;
export const DEFAULT_SORT = 'default'; 